/**
 * The window manager's numbers: the dock compass (CSS pixels), the smallest share an area keeps
 * of its parent, and the width below which one window shows at a time (a phone).
 */

/** Size of a compass square, and the distance between square centres. */
export const COMPASS = { size: 34, step: 42 };

/** Smallest share a split child can be resized to. */
export const MIN_SHARE = 0.08;

/** Below this width (CSS pixels) the workspace shows one window at a time (a phone). */
export const COMPACT_WIDTH = 720;
